import i18n from '@/lang/i18n'

export default function() {
    return [
        {
            type: 'customCheckbox'
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.externalCode'),
            colId: 'code',
            field: 'code',
            minWidth: 80
        },
        {
            type: 'text',
            headerName: i18n.tc('configuration.sections.regimes', 1),
            colId: 'nameTranslationKey',
            field: 'name',
            minWidth: 280,
            flex: 1
        },
        {
            type: 'checkIconRenderer',
            headerName: i18n.t('configuration.grid.active'),
            colId: 'active',
            field: 'active',
            flex: 2
        },
        {
            type: 'flagsRenderer',
            headerName: i18n.t('configuration.grid.translations'),
            colId: 'nameTranslations',
            field: 'nameTranslations',
            filter: false,
            sortable: false,
            flex: 2
        }
    ]
}
